import { parsePhoneNumberFromString } from 'libphonenumber-js';

import messages from '../constants/messages';

export const validatePhone = field => ({
  validator(_, value) {
    if (!value) return Promise.resolve();

    try {
      const phoneNumber = parsePhoneNumberFromString(value.startsWith('+') ? value : `+${value}`);

      if (phoneNumber && phoneNumber.isValid()) return Promise.resolve();

      return Promise.reject(new Error(messages.FIELD_INVALID(field)));
    } catch {
      return Promise.reject(new Error(messages.FIELD_INVALID(field)));
    }
  }
});
